'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function WidgetHeaderButton(_ref) {
  var iconName = _ref.iconName,
      size = _ref.size,
      className = _ref.className,
      style = _ref.style,
      onClick = _ref.onClick;

  return _react2.default.createElement(
    _UIButton2.default,
    {
      className: className,
      style: style,
      use: 'unstyled',
      size: size,
      onClick: onClick
    },
    _react2.default.createElement(_UIIcon2.default, { name: iconName })
  );
}

WidgetHeaderButton.propTypes = {
  className: _react.PropTypes.string,
  iconName: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func.isRequired,
  size: _react.PropTypes.string.isRequired,
  style: _react.PropTypes.object
};

WidgetHeaderButton.defaultProps = {
  size: 'default'
};

exports.default = WidgetHeaderButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/WidgetHeaderButton.js
// module id = 511
// module chunks = 2 3